<div class="relative mt-8 flex flex-auto flex-col items-center gap-8 px-6">
  @if (event(); as ev) {
    <div class="w-full max-w-4xl flex flex-col gap-6">
      <!-- General Header Info Card -->
      <div class="surface-default flex flex-col gap-4 rounded-xl border border-neutral-a4 p-6 shadow-sm">
        <div class="flex items-center justify-between border-b border-neutral-a4 pb-4">
          <div class="flex items-center gap-3">
            <mat-icon class="text-primary size-6 flex items-center justify-center">info</mat-icon>
            <span class="text-lg font-bold text-primary">Informations Générales</span>
          </div>
          <aura-simple-chip [text]="ev.type" />
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-8 text-sm">
          <div class="flex flex-col gap-1">
            <span class="text-xs text-neutral-11 font-medium">ID de l'événement (Stripe)</span>
            <span class="font-mono text-neutral-12 break-all">{{ ev.eventId }}</span>
          </div>

          <div class="flex flex-col gap-1">
            <span class="text-xs text-neutral-11 font-medium">Créé le (Reçu)</span>
            <span class="text-neutral-12">{{ ev.createdAt | luxonDate: 'dd/LL/yyyy, HH:mm' }}</span>
          </div>

          <div class="flex flex-col gap-1">
            <span class="text-xs text-neutral-11 font-medium">Statut du traitement</span>
            <div class="flex items-center gap-1.5">
              <div
                class="size-2 rounded-full"
                [class.bg-green-9]="ev.processed"
                [class.bg-red-9]="!ev.processed"
              ></div>
              <span class="font-medium text-neutral-12">{{
                ev.processed ? 'Traité avec succès' : 'Non traité'
              }}</span>
            </div>
          </div>

          <div class="flex flex-col gap-1">
            <span class="text-xs text-neutral-11 font-medium">Date de traitement</span>
            <span class="text-neutral-12">
              {{ ev.processedAt ? (ev.processedAt | luxonDate: 'dd/LL/yyyy, HH:mm') : 'N/A' }}
            </span>
          </div>
        </div>

        @if (ev.error) {
          <mat-divider class="my-2"></mat-divider>
          <div class="flex flex-col gap-1 bg-red-3 border border-red-8 rounded-lg p-4">
            <span class="text-xs text-red-11 font-bold flex items-center gap-1">
              <mat-icon class="text-red-9 text-sm size-4 flex items-center justify-center">error</mat-icon>
              Message d'erreur du traitement
            </span>
            <span class="font-mono text-xs text-red-11 break-all whitespace-pre-wrap">{{ ev.error }}</span>
          </div>
        }
      </div>

      <!-- Raw Event Payload -->
      <div class="surface-default flex flex-col gap-4 rounded-xl border border-neutral-a4 p-6 shadow-sm">
        <div class="flex items-center gap-3 border-b border-neutral-a4 pb-4">
          <mat-icon class="text-primary size-6 flex items-center justify-center">code</mat-icon>
          <span class="text-lg font-bold text-primary">Corps de l'événement (JSON Brut)</span>
        </div>
        <aura-code-block [code]="ev.payload" />
      </div>
    </div>
  }
</div>
